import { createFileRoute } from "@tanstack/react-router";
import StockTransferTable from "@/components/stock-transfer/stock-transfer-table";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useTranslate } from "@/hooks/use-translate";
import { useNavigate } from "@tanstack/react-router";
import { StockTransferModals } from "@/components/stock-transfer/stock-transfer-modals";

export const Route = createFileRoute("/(dasboard)/inventory/stock-transfers/")({
  component: StockTransferListBlock,
});

function StockTransferListBlock() {
  const { t } = useTranslate();
  const navigate = useNavigate();

  return (
    <section>
      <StockTransferModals />
      <header className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 gap-4">
        <h2 className="text-2xl font-semibold">{t("Stock Transfers")}</h2>
        <Button
          onClick={() => {
            navigate({ to: "/inventory/stock-transfers/create" });
          }}
        >
          <Plus className="w-4 h-4" />
          {t("Transfer Stock")}
        </Button>
      </header>
      <StockTransferTable />
    </section>
  );
}
